// src/utils/logger.js

/**
 * Development/Production için güvenli logging utility
 */

const isDevelopment = process.env.NODE_ENV === 'development';

export const logger = {
    /**
     * Development'ta console.log, production'da sessiz
     */
    log: (...args) => {
        if (isDevelopment) {
            console.log(...args);
        }
    },

    /**
     * Development'ta console.info, production'da sessiz
     */
    info: (...args) => {
        if (isDevelopment) {
            console.info(...args);
        }
    },

    /**
     * Development'ta console.warn, production'da sessiz
     */
    warn: (...args) => {
        if (isDevelopment) {
            console.warn(...args);
        }
    },

    /**
     * Her zaman loglanır (kritik hatalar için)
     */
    error: (...args) => {
        console.error(...args);
        // Burada Sentry, LogRocket gibi servislere gönderilebilir
    },

    /**
     * Debugging için kullanılır, sadece development'ta
     */
    debug: (...args) => {
        if (isDevelopment) {
            console.debug(...args);
        }
    }
};

export default logger;
